module.exports = __webpack_public_path__ + "img/order-report.3b3d3cae.png";